import { useState } from "react";
import axios from "axios";
import { Download, RefreshCw, UploadCloud } from "lucide-react";

const MOIS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];
const ZOHO = { ok: "Envoyée à Zoho", en_attente: "Envoi Zoho en cours", non_configure: "Gardée sur le serveur" };
const DRIVE = { ok: "PDF déposé dans Drive", erreur: "PDF Drive à renvoyer", non_connecte: "PDF en attente de Drive" };

const dateFr = (iso) => {
  const d = new Date(iso);
  return `${d.getDate()} ${MOIS[d.getMonth()]} ${d.getFullYear()} · ${d.getHours()} h ${String(d.getMinutes()).padStart(2, "0")}`;
};

const FicheRow = ({ f, password, api }) => {
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState("");
  const [drive, setDrive] = useState(f.pdf_drive_status);
  const [sending, setSending] = useState(false);

  const sendDrive = async () => {
    setSending(true);
    setNotice("");
    try {
      const { data } = await axios.post(`${api}/admin/fiches/${f.id}/drive`, null, { headers: { "X-Admin-Password": password } });
      setDrive(data.pdf_drive_status);
    } catch {
      setNotice("Le dépôt dans Drive demande un nouvel essai.");
    } finally {
      setSending(false);
    }
  };

  const download = async () => {
    setBusy(true);
    setNotice("");
    try {
      const res = await axios.get(`${api}/admin/fiches/${f.id}/pdf`, {
        headers: { "X-Admin-Password": password },
        responseType: "blob",
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Fiche besoins - ${f.organisation} - ${f.nom}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      setNotice("Le téléchargement demande un nouvel essai.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <li className="ob-row" data-testid={`admin-fiche-row-${f.id}`}>
      <div className="ob-row-main">
        <p className="ob-row-date">{f.date_envoi ? dateFr(f.date_envoi) : ""}</p>
        <p className="ob-row-name" data-testid="admin-fiche-name">{f.nom}</p>
        <p className="ob-row-meta">{[f.fonction, f.organisation].filter(Boolean).join(" · ")}</p>
        <p className="ob-row-meta">
          <a href={`mailto:${f.courriel}`}>{f.courriel}</a>
          <span className="ob-row-status" data-testid="admin-fiche-zoho-status">{ZOHO[f.zoho_status] || "Envoi Zoho à relancer"}</span>
          {drive && <span className="ob-row-status" data-testid="admin-fiche-drive-status">{DRIVE[drive]}</span>}
        </p>
        {notice && <p className="ob-hint">{notice}</p>}
      </div>
      <div className="ob-row-actions">
      {drive !== "ok" && (
        <button type="button" className="ob-back" onClick={sendDrive} disabled={sending} data-testid={`admin-fiche-drive-${f.id}`}>
          <UploadCloud size={14} /> {sending ? "Envoi" : "Déposer dans Drive"}
        </button>
      )}
      <button type="button" className="ob-btn ob-btn-small" onClick={download} disabled={busy} data-testid={`admin-fiche-download-${f.id}`}>
        <Download size={16} strokeWidth={2} />
        {busy ? "Préparation" : "PDF"}
      </button>
      </div>
    </li>
  );
};

export const FicheList = ({ fiches, password, api, onRefresh, onLogout }) => (
  <section data-testid="admin-fiche-list">
    {new URLSearchParams(window.location.search).get("drive") === "connecte" && (
      <p className="ob-intro" data-testid="admin-drive-connected">Google Drive est relié. Les prochains PDF arriveront dans FICHES BESOIN REMPLIES.</p>
    )}
    {new URLSearchParams(window.location.search).get("drive") === "erreur" && (
      <p className="ob-intro" data-testid="admin-drive-error">Le branchement Google Drive reste à faire : cliquez sur « Relier Google Drive » et acceptez l'accès.</p>
    )}
    <div className="ob-admin-bar">
      <p className="ob-label" data-testid="admin-fiche-count">
        {fiches.length} {fiches.length > 1 ? "fiches reçues" : "fiche reçue"}
      </p>
      <div className="ob-admin-actions">
        <button type="button" className="ob-back" onClick={onRefresh} data-testid="admin-refresh-button">
          <RefreshCw size={14} /> Actualiser
        </button>
        <a className="ob-back" href={`${api}/drive/connect?password=${encodeURIComponent(password)}`} data-testid="admin-drive-connect-link">
          <UploadCloud size={14} /> Relier Google Drive
        </a>
        <button type="button" className="ob-back" onClick={onLogout} data-testid="admin-logout-button">Fermer la session</button>
      </div>
    </div>
    {fiches.length ? (
      <ul className="ob-rows">
        {fiches.map((f) => <FicheRow key={f.id} f={f} password={password} api={api} />)}
      </ul>
    ) : (
      <p className="ob-intro" data-testid="admin-empty">Les prochaines fiches apparaîtront ici dès leur envoi.</p>
    )}
  </section>
);
